import RadioCheckedIcon from 'assets/icons/radio-checked-icon.svg';
import RadioDisableIcon from 'assets/icons/radio-disable-icon.svg';
import RadioboxHHMTIcon from 'assets/icons/radiobox-hhmt-icon.svg';
import RadioboxRemoxIcon from 'assets/icons/radiobox-remox-icon.svg';
import useTheme from 'hooks/useTheme';
import React from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import { paragraph500Mixin } from 'styles';

const FormCheckboxRadio = ({
  name = '',
  className = '',
  type = 'radio',
  label = '',
  isChecked = false,
  isInvalid = false,
  isDisabled = false,
  onClick = () => {},
  styles = {},
  labelStyles = {},
}) => {
  const { isHHMTTheme } = useTheme();

  return (
    <FormCheckboxRadioStyled onClick={onClick}>
      <FormCheck
        name={name}
        className={className}
        type={type}
        label={label}
        checked={isChecked}
        $checkboxSrc={
          isDisabled
            ? RadioDisableIcon
            : isHHMTTheme
            ? RadioboxHHMTIcon
            : RadioboxRemoxIcon
        }
        isInvalid={isInvalid}
        $isDisabled={isDisabled}
        onClick={onClick}
        inline
        readOnly
        style={styles || {}}
        $labelStyles={labelStyles || {}}
      />
    </FormCheckboxRadioStyled>
  );
};

const FormCheckboxRadioStyled = styled.div`
  display: contents;
  width: fit-content;
`;

const FormCheck = styled(Form.Check)`
  margin: 0;
  margin-right: 44px;

  & label {
    ${paragraph500Mixin};
    color: ${(props) =>
      props.$isDisabled
        ? 'var(--ds-c-grey-neutral)'
        : 'var(--ds-c-grey-dark)'}!important;
    margin-left: 0px;
    cursor: pointer !important;
    user-select: none;
    ${(props) => props.$labelStyles};
  }

  & input {
    border: none;
    border-radius: 2px;
    background-image: ${(props) => `url(${props.$checkboxSrc}) !important`};
    background-position: center !important;
    width: 16px;
    height: 16px;
    cursor: pointer !important;

    &:focus,
    &:active,
    &:checked {
      background-color: transparent;
      border: none;
      border-radius: 2px;
      box-shadow: none !important;
      filter: none !important;
    }
  }

  &.active {
    & label {
      font-weight: 700;
    }

    & input {
      background-image: url(${RadioCheckedIcon}) !important;
    }
  }
`;

export default FormCheckboxRadio;
